import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase } from '../../../../form-atyl-base'


@Component({
	selector: 'atyl-form-input-text',
	templateUrl: './form-input-text.component.html',
	styleUrls: ['./form-input-text.component.scss']
})
export class FormInputTextComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>();
	label: string
	errorString: string

	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) { }

	ngOnInit(): void {
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}
	setToUpper(newObj: any, sousElem?: any) {
		if (sousElem)
			this.group.get(String(this.forminput.ID)).get(sousElem).setValue(newObj.target.value.toUpperCase())
		else
			this.group.get(String(this.forminput.ID)).setValue(newObj.target.value.toUpperCase())
	}
	customBehaviourHandler(event:any,customBehaviour: any) {
		var ev:any= {
			event: event  as Event,
			forminput:this.forminput,
			customBehaviour:this.forminput.customBehaviour,
			control:this.group.get(this.forminput.ID)
		}
		
		this.inputTyped.emit(ev)
	}
	replaceValue(newValue: any) {
		this.group.get(String(this.forminput.ID)).setValue(newValue.value)
	}
}
